import React, { useEffect, useRef } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import styled from "styled-components/macro";

import { SaleAction, setActiveRole, setCurrentLivestockSaleId } from "actions";

import { SlimButton } from "components/Button";
import { CenteredGreedy, Row } from "components/Layout";
import LoadingSpinner from "components/LoadingSpinner";
import {
  AgrinousSupportEmailLink,
  AgrinousSupportPhoneLink,
} from "components/Support";
import { BigText } from "components/Text";

import { colors } from "constants/theme";

import { getDashboardRoute } from "lib/navigation";

import { getRoleBySlug, getSaleById } from "selectors";

import AgriNousIcon from "img/AgriNous-icon";

const FullscreenContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
`;

const NotFoundInfoComponent = ({ missingDataVariable }) => {
  const history = useHistory();
  const goToDashboard = () => {
    history.push(getDashboardRoute());
  };
  return (
    <FullscreenContainer>
      <CenteredGreedy>
        <Row>
          <AgriNousIcon color={colors.primary} scale={2} size={25} />
        </Row>
        <br />
        <BigText>Not Found</BigText>
        <p>You do not have access to this {missingDataVariable}.</p>
        <Row>
          <SlimButton onClick={goToDashboard}>Go Back</SlimButton>
        </Row>
        <br />
        <p className="text-center p-2">
          For further support, contact us via email at{" "}
          <AgrinousSupportEmailLink />
          <br /> or call us on <AgrinousSupportPhoneLink />
        </p>
      </CenteredGreedy>
    </FullscreenContainer>
  );
};

export const RedirectToSale = ({ match }) => {
  const { livestockSaleId, userRole } = match.params;
  const role = useSelector(getRoleBySlug(userRole));
  const dispatch = useDispatch();
  const sale = useSelector(getSaleById(+livestockSaleId));
  const hasRequestedSale = useRef(false);

  useEffect(() => {
    if (role) {
      dispatch(setActiveRole(role));
    }
  }, [dispatch, role]);

  useEffect(() => {
    if (sale) {
      dispatch(setCurrentLivestockSaleId(sale.livestocksale_id, true, false));
    } else if (!hasRequestedSale.current) {
      // Sale not in cache (may be older than 90 days), fetch it directly
      hasRequestedSale.current = true;
      dispatch(SaleAction.requestOne({ id: +livestockSaleId }));
    }
  }, [dispatch, sale, livestockSaleId]);

  if (!role) {
    return <NotFoundInfoComponent missingDataVariable="User Role" />;
  }

  return (
    <FullscreenContainer>
      <CenteredGreedy>
        <LoadingSpinner actionName="Loading" subjectName="role and sales" />
      </CenteredGreedy>
    </FullscreenContainer>
  );
};
